<template>
    <page>
        <module>
            <view-list work-type="22" ref="view" selector :view-config="auth('b_aftersale_visit_service_viewmanage')">
                <template #search>
                    <m-search ref="search">
                        <m-search-item label="单据编号">
                            <c-input name="service_record_number"></c-input>
                        </m-search-item>
                        <m-search-item label="工单编号">
                            <c-input name="order_number"></c-input>
                        </m-search-item>
                        <m-search-item label="申请单编号">
                            <c-input name="apply_order_code"></c-input>
                        </m-search-item>
                        <m-search-item label="服务类型">
                            <c-select name="service_type" :options="serviceTypeDic"></c-select>
                        </m-search-item>
                        <m-search-item label="售后类型">
                            <c-select name="aftersale_type" :options="afterSaleTypeDic"></c-select>
                        </m-search-item>
                        <m-search-item label="客户名称">
                            <c-input name="customer_name"></c-input>
                        </m-search-item>
                        <m-search-item label="状态">
                            <c-select name="status" :options="visitServiceStatusDic"></c-select>
                        </m-search-item>
                        <m-search-item label="推送状态">
                            <c-select name="push_status" :options="visitServicePushStatusDic"></c-select>
                        </m-search-item>

                        <m-search-item label="创建时间" colspan="2">
                            <c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
                        </m-search-item>
                    </m-search>
                </template>

                <template #operate>
                    <c-button color="main" v-if="auth('b_aftersale_visit_service_edit')" prepend-icon="tf-add" @click="editRecord()">创建上门服务记录单</c-button>
                    <c-button v-if="auth('b_aftersale_visit_service_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
                </template>
                <template #batchOperate="{data}">
                    <c-button v-if="auth('b_aftersale_visit_service_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
                </template>
                <template #service_type="{data}">
                    <c-state dict="serviceTypeDic"  :value="data.service_type"></c-state>
                </template>

                <template #aftersale_type="{data}">
                    <c-state dict="afterSaleTypeDic"  :value="data.aftersale_type"></c-state>
                </template>
                <template #service_record_number="{data}">
                    <c-link @click="globalDialog('visitServiceDetail', {props: {id: data.id}})">{{data.service_record_number}}</c-link>
                </template>
                <template #order_number="{data}">
                    <c-link v-if="auth('b_aftersale_order_query')" @click="globalDialog('afterSaleOrderDetail', {props: {id: data.order_id}})">{{data.order_number}}</c-link>
                    <span v-else>{{data.order_number}}</span>
                </template>
                <template #aftersale_apply_no="{data}">
                    <c-link v-if="auth('b_aftersale_apply_view')" @click="globalDialog('aftersaleApplyDetail', {props: {id: data.apply_id}})">{{data.aftersale_apply_no}}</c-link>
                    <span v-else>{{data.aftersale_apply_no}}</span>
                </template>

                <template #status="{data}">

                    <span v-if="data.status==-1">
                       草稿
                    </span>
                    <span v-if="data.status==2" style="color: green;">
                       已提交
                    </span>
                    <span v-if="data.status==4" style="color: red;">
                       已撤回
                    </span>
                </template>

                <template #is_charge="{data}">
                    <c-state dict="isChargeDic" :value="data.is_charge"></c-state>
                </template>

                <template #is_send_car="{data}">
                    <c-state dict="isChargeDic" :value="data.is_send_car"></c-state>
                </template>

                <template #is_use_machine="{data}">
                    <c-state dict="isChargeDic" :value="data.is_use_machine"></c-state>
                </template>
                <template #is_finish="{data}">
                    <c-state dict="isChargeDic" :value="data.is_finish"></c-state>
                </template>

                <template #service_days="{data}">
                    {{data.service_days}} 天
                </template>

                <template #accommodation_days="{data}">
                    {{data.accommodation_days}} 晚
                </template>

                <template #traffic_fee="{data}">
                    ￥{{data.traffic_fee}}
                </template>
                <template #total_amount="{data}">
                    ￥{{data.total_amount}}
                </template>
                <template #notice_amount="{data}">
                    ￥{{data.notice_amount}}
                </template>

                <template #service_type="{data}">
                    <c-state dict="serviceTypeDic" :value="data.service_type"></c-state>
                </template>

                <template #aftersale_type="{data}">
                    <c-state dict="afterSaleTypeDic" :value="data.aftersale_type"></c-state>
                </template>

                <template #push_status="{data}">
                    <span v-if="data.push_status==1">
                       待推送
                    </span>
                    <span v-if="data.push_status==2" style="color: green;">
                       已推送
                    </span>
                </template>

                <c-table-column
                        type="button"
                        label="操作"
                        width="200"
                        button-limit="4"
                >
                    <template #default="{data}">
                        <c-table-button icon="tf-detail" @click="globalDialog('visitServiceDetail', {props: {id: data.id}})">查看</c-table-button>
                        <c-table-button v-if="auth('b_aftersale_visit_service_edit') && data.status == -1" :disabled="!(data.status == -1)" icon="tf-edit" @click="editRecord(data)">
                            编辑
                        </c-table-button>
                        <c-table-button v-if="auth('b_aftersale_visit_service_edit') && data.status == 2" :disabled="!(data.status == 2)" icon="tf-edit" @click="withdrawRecord(data)">
                            撤回
                        </c-table-button>
                        <c-table-button v-if="auth('b_aftersale_visit_service_edit') && data.status == 4" :disabled="!(data.status == 4)" icon="tf-edit" @click="resubmitRecord(data)">
                            重新提交
                        </c-table-button>
                        <c-table-button v-if="auth('b_aftersale_visit_service_edit') && data.status == -1" icon="tf-trash" @click="removeRecord(data)">删除</c-table-button>
                    </template>
                </c-table-column>
            </view-list>

        </module>
    </page>
</template>

<script>
import {mapState} from 'vuex'

export default {
    data() {
        return {
            workType: 22
        }
    },

    computed: {
        ...mapState(['serviceTypeDic', 'afterSaleTypeDic', 'isChargeDic']),

        visitServiceStatusDic() {
            return [
                { name: '草稿', value: '-1' },
                { name: '已提交', value: '2' },
                { name: '已撤销', value: '4' },
            ];
        },
        visitServicePushStatusDic() {
            return [
                { name: '待推送', value: '1' },
                { name: '已推送', value: '2' },
            ];
        },
    },

    methods: {
        editRecord(data = {}) {
            this.globalDialog('visitServiceEdit', {props: {id: data.id, isResubmit: false}}, this.$refs.view.$refs.list.update);
        },

        resubmitRecord(data = {}) {
            this.globalDialog('visitServiceEdit', {props: {id: data.id, isResubmit: true}}, this.$refs.view.$refs.list.update);
        },

        removeRecord(data) {
            this.$confirm({
                message: '确认删除上门服务记录单【' + data.service_record_number + '】？删除后不可恢复',
                cancelButton: true,
                resolve: () => {
                    this.request({
                        url: '/aftersale/visit_service/remove',
                        data: { id: data.id },
                        loading: true,
                        success: data => {
                            this.$message({
                                message: '删除成功',
                                type: 'success'
                            });
                            this.$refs.view.$refs.list.refresh();
                        }
                    });
                },
                cancel: () => {}
            });
        },
        withdrawRecord(data) {
            this.$confirm({
                message: '确认撤回上门服务记录单【' + data.service_record_number + '】？',
                cancelButton: true,
                resolve: () => {
                    this.request({
                        url: '/aftersale/visit_service/withdraw',
                        data: { id: data.id },
                        loading: true,
                        success: data => {
                            this.$message({
                                message: '撤回成功',
                            })
                            this.$refs.view.$refs.list.refresh();
                        }
                    })
                }
            })
        }
    }
}
</script>

<style lang="stylus" scoped>
</style>
